import { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { RoutesEnum } from '../../utils/routesEnum'

const NewLandingPage = (): ReactElement | null => {
  return (
    <>
      Carregando...
      <div style={{ opacity: 0 }}>
        {Object.entries(RoutesEnum).map(([key, value]) => {
          if (value.includes(':')) {
            return null
          }

          return (
            <Link key={key} to={value}>
              {key}
            </Link>
          )
        })}
      </div>
    </>
  )
}

export default NewLandingPage
